import * as Views from "./views";

const Module = {
    name: "contoeconomicoattributionrulegroups",
    defaultRoutePath: "/incomestatements/contoeconomicoattributionrulegroup",
    menuItemScope: "incomestatements",
    menuItemName: "contoeconomicoattributionrulegroups",
    routes: [
        {
            path: "/incomestatements/contoeconomicoattributionrulegroup",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Views.Create,
        },
    ],

}

export default Module;
